import { render, staticRenderFns } from "./companyReportTabOrders.vue?vue&type=template&id=1508d112"
import script from "./companyReportTabOrders.vue?vue&type=script&lang=js"
export * from "./companyReportTabOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports